<template>
  <div class="doc-container" v-if="documents.length > 0">
    <v-row class="mb-8">
      <v-col class="instructions">
        <h1>Required Documents</h1>
      </v-col>
    </v-row>
    <div class="documents-list">
      <div
        v-for="(doc, index) in documents"
        :key="doc.name"
        class="document-item"
      >
        <div class="document-info">
          <div class="document-name">{{ getDocumentLabel(doc) }}</div>
          <div class="document-status">
            <span v-if="doc.uploaded" class="status-chip success">
              <v-icon small>fas fa-check</v-icon>
              <span>Uploaded</span>
              <span class="upload-date">({{ doc.uploaded }})</span>
            </span>
            <span v-else-if="!isOptionalDoc(doc)" class="status-chip error">
              <v-icon small>fas fa-exclamation-triangle</v-icon>
              <span>Missing</span>
            </span>
            <span v-else class="status-chip optional">
              <span>Optional</span>
            </span>
          </div>
        </div>
        <div class="document-action">
          <v-file-input
            v-model="doc.file"
            prepend-icon=""
            class="file-input"
            :ref="`upload-${index}`"
            hide-details="auto"
            :clearable="false"
            accept="application/pdf, image/png, image/jpeg, image/svg+xml, image/gif"
            @change="$emit('upload-document', doc)"
          >
            <template v-slot:prepend-inner>
              <v-btn
                outlined
                color="primary"
                @click.stop="$refs[`upload-${index}`][0].$refs.input.click()"
              >
                <v-icon left>fas fa-upload</v-icon>
                Choose File
              </v-btn>
            </template>
          </v-file-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequiredDocumentsList',
  props: {
    documents: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    getDocumentLabel(doc) {
      const docLabel = doc.label ? `(${doc.label})` : '';
      const docFeature = doc.feature ? `(${doc.feature})` : '';
      const docType = doc.type ? `for ${doc.type}` : '';
      return `${doc.name} ${docFeature} ${docType} ${docLabel}`;
    },
    isOptionalDoc(doc) {
      return ['CancelledCheck', 'BrokerageStatement'].includes(doc.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.doc-container {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 80px;
}

.documents-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.document-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: var(--color-background, white);
  border: 1px solid var(--color-border, #E0E0E0);
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: var(--color-background-hover, #F5F5F5);
  }
}

.document-info {
  flex: 1;
  min-width: 0;
  margin-right: 16px;

  .document-name {
    font-weight: 500;
    font-size: 14px;
    color: var(--color-text-primary, #333333);
    margin-bottom: 2px;
  }
}

.document-status {
  display: flex;
  align-items: center;
  gap: 4px;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;

  &.success {
    background-color: var(--color-success, #4CAF50);
    color: white;

    .v-icon {
      color: white !important;
    }
  }

  &.error {
    background-color: var(--color-error-light, #FFEBEE);
    color: var(--color-error, #F44336);
  }

  &.optional {
    background-color: var(--color-grey-light, #F5F5F5);
    color: var(--color-grey, #9E9E9E);
  }

  .upload-date {
    font-size: 10px;
    opacity: 0.8;
    color: white;
  }
}

.document-action {
  .file-input {
    max-width: 150px;
  }

  .v-btn {
    height: 32px;
    padding: 0 12px;
    font-size: 13px;
    
    .v-icon {
      font-size: 14px;
      margin-right: 6px;
    }
  }
}
</style> 